module.exports = __webpack_public_path__ + "img/folder.792e15be.svg";